// extracted by mini-css-extract-plugin
module.exports = {"comments":"Post_comments__2YyOf","message":"Post_message__IiRG3","textMessage":"Post_textMessage__1PvV8"};